import { ListData } from '@fi-app/components/items-list/list-data.service';
import { FranchiseIntranetUpgradeModel } from '../franchise-intranet-upgrade.model';
import { FiDisplayType } from '@fi-shared/types/display-type';
import { ObjectTypes } from '@fi-shared/types/object-type';
import {
    ItemsListElementType,
    ItemsListHeader,
    ItemsListHeaderProperties,
} from '@fi-app/components/items-list/items-list-header';
import { Injector } from '@angular/core';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export class FiFranchiseIntranetUpgradeListDataModel extends ListData<FranchiseIntranetUpgradeModel> {
    constructor(injector: Injector, isLocalSort?: boolean) {
        super(injector, isLocalSort, 'VersionMajor', true);

        this.ShowDelete = false;
        this.DisplayType = FiDisplayType.List;
        this.ObjectType = ObjectTypes.CustomFranchiseIntranetUpgrade;
        this.ShowCheckBox = false;

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('upgrade.version_number'),
                'VersionNumber',
                new ItemsListHeaderProperties('', true, ItemsListElementType.A, {
                    Sref: FiStateNames.Upgrade.View,
                    SrefParams: (data) => ({ Id: data.Id }),
                    secondaryValue: (data: FranchiseIntranetUpgradeModel) =>
                        data.getVersionTypeName(this.appTextService),
                }),
                undefined,
                undefined,
                'VersionNumberText',
            ),
        );

        this.addSpanPlainHeader(this.appTextService.get('common.description'), 'InternalDescription', '', false);

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('upgrade.upgrade_date'),
                'UpgradeOn',
                new ItemsListHeaderProperties('Ccm-Date', true, ItemsListElementType.DateTime),
            ),
        );

        this.addSpanPlainHeader(
            this.appTextService.get('common.status'),
            'UpgradeStatusType',
            '',
            true,
            (data: FranchiseIntranetUpgradeModel) => {
                return data.getUpgradeStatusTypeText(this.appTextService);
            },
        );

        this.addChangedOnHeader();
    }
}
